import { Component, Input } from '@angular/core';
import { Documento } from '../../models/Document';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-estados-documento',
    imports: [
        MatIconModule,
        MatTooltipModule
    ],
    templateUrl: './estados-documento.component.html',
    styleUrl: './estados-documento.component.scss'
})
export class EstadosDocumentoComponent {
  @Input() documento!: Documento
}
